import { useState } from 'react';
import { Col, FormCheck, Row } from 'react-bootstrap';
import Form from '../../../CompUtils/Form';
import Terminos from './Terminos';
type Props = {
  handleSubmitStep2: (valores: any) => void;
};

const Step2Terminos = (props: Props) => {
  const { handleSubmitStep2 } = props;
  const [termsAccepted, setTermsAccepted] = useState(false);

  const toggleButtons = () => {
    return !termsAccepted;
  };

  const handleTermsCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTermsAccepted(event.target.checked);
  };

  return (
    <>
      <Form
        submitText="Inscribirme"
        onSubmit={handleSubmitStep2}
        noBtns={toggleButtons()}
        btns={['submit']}>
        <Row>
          <Col xs={12}>
            <p>
              <strong>Términos y Condiciones.</strong>
            </p>
            <>
              <Terminos />
            </>
          </Col>
        </Row>
        <Col xs={12} className="d-flex justify-content-end align-items-center">
          <FormCheck>
            <FormCheck.Input
              type="checkbox"
              id="termsCheckbox"
              checked={termsAccepted}
              onChange={handleTermsCheckboxChange}
            />
            <FormCheck.Label htmlFor="termsCheckbox">
              Acepto los términos y condiciones
            </FormCheck.Label>
          </FormCheck>
        </Col>
      </Form>
    </>
  );
};

export default Step2Terminos;
